import React, { useEffect, useState } from "react";
import ApiTrafficChart from "../SideBarMenu/components/ApiTrafficChart";
import ApiUsageBarChart from "../SideBarMenu/components/ApiUsageBarChart";
import ApiStatusPie from "../SideBarMenu/components/ApiStatusPie";
import { Link } from "react-router-dom";
import {
  getEndpointOrServiceName,
  getTopUsedService,
} from "../../services/dashboardService";
import { showSuccessToast } from "../../utils/toastUtils";
import ServiceFetcher from "./ServiceFetcher";

// Reusable Stat Card Component
const StatCard = ({ title, value, trend, color, border }) => (
  <div
    className={`bg-white border border-gray-200 p-6 rounded-2xl shadow-sm ${border}`}
  >
    <p className="text-gray-500 text-sm">{title}</p>
    <h3 className={`text-3xl font-bold mt-1 ${color || "text-gray-900"}`}>
      {value}
    </h3>
    {trend && <p className="text-emerald-600 text-xs mt-2">{trend}</p>}
  </div>
);

const ApiAdminDashboard = () => {
  const testNotification = async () => {
    try {
      if (!("Notification" in window)) {
        console.log("Notifications are not supported");
        return;
      }

      console.log("Permission:", Notification.permission);

      if (Notification.permission === "default") {
        const permission = await Notification.requestPermission();

        console.log("Permission result:", permission);

        if (permission !== "granted") {
          return;
        }
      }

      if (Notification.permission !== "granted") {
        console.log("Notification permission is not granted");
        return;
      }

      const registration = await navigator.serviceWorker.ready;

      console.log("Service Worker ready:", registration);

      await registration.showNotification("IDSPay Test", {
        body: "📱 Mandate notification test is working!",
        icon: "/favicon.ico",
      });

      console.log("Notification sent");
    } catch (error) {
      console.error("Notification error:", error);
    }
  };

  return (
    <div className="flex min-h-screen overflow-hidden pt-6 bg-gray-100 text-gray-900 font-sans">
      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto p-8">
        {/* Header */}
        <header className="flex flex-col lg:flex-row gap-4 lg:justify-between items-center mb-10">
          <div>
            <h2 className="text-3xl font-bold">Systems Overview</h2>
            <p className="text-gray-500">
              Real-time API performance & monitoring
            </p>
          </div>

          <div className="flex space-x-4">
            <button className="px-4 py-2 text-xs md:text-[16px] bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
              Export Logs
            </button>

            <button className="px-6 text-xs md:text-[16px] py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition shadow-md">
              {/* <link rel="stylesheet" href="https://apiuser.idspay.in/SignUpForm" target /> */}
              <Link
                target="_blank"
                to={"https://idspayenterprise.com/SignUpForm"}
              >
                + Create Partner Account
              </Link>
            </button>
            <button className="px-6 py-2 text-xs md:text-[16px] bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition shadow-md">
              {/* <link rel="stylesheet" href="https://apiuser.idspay.in/SignUpForm" target /> */}
              <Link target="_blank" to={"https://apiuser.idspay.in/SignUpForm"}>
                + Create API Account
              </Link>
            </button>
          </div>
        </header>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <StatCard
            title="Total Requests (24h)"
            value="1.2M"
            trend="↑ +12% vs yesterday"
          />
          <StatCard
            title="Avg. Latency"
            value="42ms"
            color="text-blue-600"
            trend="Server Status: Optimal"
          />
          <StatCard
            title="Active API Keys"
            value="842"
            border="border-l-4 border-emerald-500"
            trend="14 pending verification"
          />
          <StatCard
            title="Error Rate"
            value="0.04%"
            color="text-red-500"
            trend="2 timeouts reported"
          />
        </div>

        <button
          className="bg-blue-600 hidden text-white p-4 my-2 rounded-md"
          onClick={testNotification}
        >
          Test Mobile Notification
        </button>

        {/* service fetcher */}
        <ServiceFetcher />
        {/* Bottom Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Traffic Table */}
          <div className="lg:col-span-2 bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
            <div className="p-6 border-b border-gray-200 flex justify-between items-center">
              <h4 className="font-bold">Live API Traffic</h4>
              <span className="px-3 py-1 bg-emerald-100 text-emerald-700 text-xs rounded-full">
                Live
              </span>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr className="text-gray-500 text-xs uppercase border-b border-gray-200">
                    <th className="px-6 py-4">Service</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4">IP Address</th>
                    <th className="px-6 py-4 text-right">Time</th>
                  </tr>
                </thead>

                <tbody className="text-sm">
                  {[
                    {
                      service: "Credit_Report_v2",
                      status: "200 OK",
                      ip: "192.168.1.45",
                      time: "Just now",
                      color: "text-emerald-600",
                    },
                    {
                      service: "KYC_Verification",
                      status: "200 OK",
                      ip: "45.22.110.5",
                      time: "2 min ago",
                      color: "text-emerald-600",
                    },
                    {
                      service: "KYB_Bulk_Check",
                      status: "429 Rate Limit",
                      ip: "102.16.88.22",
                      time: "5 min ago",
                      color: "text-yellow-600",
                    },
                  ].map((row, idx) => (
                    <tr
                      key={idx}
                      className="border-b border-gray-100 hover:bg-gray-50 transition"
                    >
                      <td className="px-6 py-4 font-medium">{row.service}</td>
                      <td className={`px-6 py-4 ${row.color}`}>{row.status}</td>
                      <td className="px-6 py-4 font-mono text-gray-500">
                        {row.ip}
                      </td>
                      <td className="px-6 py-4 text-gray-500 text-right">
                        {row.time}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Service Health */}
          <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
            <h4 className="font-bold mb-6">Service Health</h4>

            <div className="space-y-6">
              {[
                {
                  label: "Main Gateway",
                  val: "99.9%",
                  color: "bg-emerald-500",
                  width: "w-[99.9%]",
                },
                {
                  label: "DB Cluster",
                  val: "82% Load",
                  color: "bg-blue-500",
                  width: "w-[82%]",
                },
                {
                  label: "Storage (S3)",
                  val: "65% Full",
                  color: "bg-yellow-500",
                  width: "w-[65%]",
                },
              ].map((bar) => (
                <div key={bar.label}>
                  <div className="flex justify-between text-sm mb-2">
                    <span>{bar.label}</span>
                    <span className="text-gray-600 font-mono">{bar.val}</span>
                  </div>

                  <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
                    <div className={`${bar.color} h-full ${bar.width}`}></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 p-4 bg-gray-50 rounded-xl border border-gray-200 text-center">
              <p className="text-xs text-gray-500 italic">
                Next scheduled maintenance in 14 hours.
              </p>
            </div>
          </div>
        </div>
      </main>
      {/* 
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
        <ApiTrafficChart />

        <ApiUsageBarChart />
        <ApiStatusPie />
      </div> */}
    </div>
  );
};

export default ApiAdminDashboard;
